import React from 'react'
import PropTypes from 'prop-types'

import ComparableWrapper from 'agency/digital_renderer/components/ComparableWrapper'

import ContentHolder from '../../ui/ContentHolder'
import Comparable from './Comparable'
import styles from './styles.scss'

const renderComparables = (brand, comparables) => comparables.map(comparable => <Comparable key={comparable.id} brand={brand} campaignComparable={comparable} />)

const AgencyProperties = (props) => {
  const { brand, campaign } = props
  return (
    <ComparableWrapper
      campaign={campaign}
      comparableSource="agency"
      render={({ comparables }) => (
        <div className={styles.root}>
          <ContentHolder>
            <h4>Our Properties</h4>

            <div className={styles.holder}>{renderComparables(brand, comparables)}</div>
          </ContentHolder>
        </div>
      )}
    />
  )
}

AgencyProperties.propTypes = {
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default AgencyProperties
